import React, { FC } from 'react';
import { Button, Popconfirm } from 'antd';
import { useTranslation } from 'react-i18next';

import { RemoveIcon } from '~/img';
import { usePermissions } from '~/hooks';
import { useTerminalsDelete } from '~/hooks/terminals';

interface TerminalBlockProps {
  id: string;
  closeParent: () => void;
}

const TerminalBlock: FC<TerminalBlockProps> = (props) => {
  const { id, closeParent } = props;
  const [t] = useTranslation();

  const { mutate, isLoading } = useTerminalsDelete(closeParent);

  const hasAccessDelete = usePermissions('business.terminal.delete');
  if (!hasAccessDelete) return null;
  return (
    <Popconfirm
      title={t('areYouSure')}
      okText={t('yes')}
      cancelText={t('no')}
      onConfirm={() => mutate({ id })}
    >
      <Button danger type="text" icon={<RemoveIcon />} loading={isLoading}>
        {t('close')}
      </Button>
    </Popconfirm>
  );
};

export default TerminalBlock;
